import { Box, Link, Typography } from "@mui/material";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { type ManualSearchResult } from "../types";

export const MANUAL_SEARCH_EMPTY_MESSAGE =
  "該当する項目が見つかりませんでした。言葉を変えてお試しください。";

interface ManualSearchResultsProps {
  results: ManualSearchResult[];
}

export const ManualSearchResults: React.FC<ManualSearchResultsProps> = ({
  results,
}) => {
  if (results.length === 0) {
    return (
      <Typography variant="body2">{MANUAL_SEARCH_EMPTY_MESSAGE}</Typography>
    );
  }

  return (
    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
      {results.map((result, index) => (
        <Box component="li" key={`${result.link}-${index}`} sx={{ py: 0.5 }}>
          <Link
            href={result.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ display: "inline-flex", alignItems: "flex-start", gap: 0.5 }}
          >
            <span>{result.title}</span>
            <OpenInNewRoundedIcon sx={{ mt: 0.25, fontSize: 16 }} />
          </Link>
        </Box>
      ))}
    </Box>
  );
};
